// extracted by mini-css-extract-plugin
module.exports = {"container":"NoContent_container__dZFWB"};